import React, { useState, useEffect } from "react";
import { Accordion, AccordionItem } from "@msi/cobalt-react/accordion";
import "./SidebarApi.css";

interface AccordionItemProps {
    apiContent?: any[];
    onEndpointSelect?: (endpoint: any) => void; // Add callback prop
    onDetailsSelect?: () => void; // Add callback for details selection
    onMetadataSelect?: () => void; // Add callback for metadata selection
    hasGovernanceMetadata?: boolean; // Whether the API has apiCenterMetadata
}

const SidebarApi: React.FC<AccordionItemProps> = ({ apiContent, onEndpointSelect, onDetailsSelect, onMetadataSelect, hasGovernanceMetadata }) => {
    const [selectedItem, setSelectedItem] = useState<string>("Details");
    const [endpoints, setEndpoints] = useState<any[]>([]);
    const [uriByTag, setUriByTag] = useState<Record<string, any[]>>({});


    const handleEndpoint = (endpoint: any[]) => {
        endpoints?.forEach((item, id) => {
            //console.log('Endpoint:', item);
        });
    }

    const groupEndpointsByTag = (endpoints: any[]) => {
        const grouped: Record<string, any[]> = {};

        endpoints.forEach((item) => {
            if (item.tags && item.tags.length > 0) {
                const tag = item.tags[0]; // Use first tag
                if (!grouped[tag]) {
                    grouped[tag] = [];
                }
                grouped[tag].push(item);
            } else {
                // Handle endpoints without tags
                if (!grouped['No Tag']) {
                    grouped['No Tag'] = [];
                }
                grouped['No Tag'].push(item);
            }
        });

        return grouped;
    }

    const handleClick = (itemName: string) => {
        setSelectedItem(itemName);
    }

    const handlePageContent = (item: any) => {
        // Call the parent's callback function with the selected endpoint
        if (onEndpointSelect) {
            onEndpointSelect(item);
        }

        // Update local selected item for UI state
        setSelectedItem(item.summary || item.content || "Selected");
        //console.log('Selected item:', item.summary);
    }

    const handleDetailsClick = () => {
        setSelectedItem("Details");
        
        // Scroll to the API details section
        const detailsSection = document.getElementById('basic-information-section');
        if (detailsSection) {
            detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        
        // Call parent callback if provided
        if (onDetailsSelect) {
            onDetailsSelect();
        }
    }

    const handleEndpointsClick = () => {
        setSelectedItem("Endpoints");
        // You can add scroll behavior for endpoints section if needed
    }

    const handleMetadataClick = () => {
        setSelectedItem("Metadata");

        const metadataSection = document.getElementById('governance-metadata-section');
        if (metadataSection) {
            metadataSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (onMetadataSelect) {
            onMetadataSelect();
        }
    }

    useEffect(() => {
        if (apiContent && apiContent.length > 0) {
            setEndpoints(apiContent);
            handleEndpoint(apiContent);
        } else {
            setEndpoints([]);
            setUriByTag({});
        }
    }, [apiContent]);

    useEffect(() => {
        if (endpoints && endpoints.length > 0) {
            const grouped = groupEndpointsByTag(endpoints);
            setUriByTag(grouped);
        }
    }, [endpoints]);

    return (
        <div>
            <button 
                className={`detail-button ${selectedItem === "Details" ? 'selected' : ''}`}
                onClick={handleDetailsClick}
                type="button"
            >
                Details
            </button>
            { hasGovernanceMetadata &&
                <button
                    className={`detail-button ${selectedItem === "Metadata" ? 'selected' : ''}`}
                    onClick={handleMetadataClick}
                    type="button"
                >
                    Metadata / Technical Details
                </button>
            }
            { Object.entries(uriByTag).length > 0 && 
                <button 
                    className={`detail-button ${selectedItem === "Endpoints" ? 'selected' : ''}`}
                    onClick={handleEndpointsClick}
                    type="button"
                >
                    Endpoints
                </button>
            }
            <Accordion className="accordion-style">
                {Object.entries(uriByTag).map(([tag, items]) => (
                    <AccordionItem
                        key={tag}
                        title={tag === 'No Tag' ? 'default' : tag}
                        collapsable
                        selected={selectedItem === tag ? "true" : "false"}
                        onClick={() => handleClick(tag)}
                    >
                        {items.map((item, index) => (
                            <AccordionItem
                                key={`${tag}-${index}`}
                                title={
                                    (item.description && item.description.length > 28
                                        ? item.description.slice(0, 28) + "..."
                                        : item.description) ||
                                    (item.content && item.content.length > 28
                                        ? item.content.slice(0, 28) + "..."
                                        : item.content) ||
                                    "No Title"
                                }
                                selected={selectedItem === item.description ? "true" : "false"}
                                onClick={() => handlePageContent(item)}
                            >
                            </AccordionItem>
                        ))}
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};

export default SidebarApi;
